import { CTASection } from "../shared/cta-section";

export const CTA = () => {
  return (
    <CTASection
      id="call-to-action"
      title="Ready to explore how satellite monitoring can transform your
          compliance operations?"
      description="Contact Haizea Analytics to learn more about our Sentinel-2 data and Terrak.io platform."
      buttons={[
        {
          text: "Terrak.io Platform",
          href: "https://terrak.io/",
          backgroundColorClass: "bg-haizea-orange",
        },
      ]}
    />
  );
};
